"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _DataStore = _interopRequireWildcard(require("./../Stores/DataStore2"));

var _v = _interopRequireDefault(require("uuid/v1"));

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../targets/cord_eurofh_teams/config.js"));

var _BuildConstants = require("../../utils/BuildConstants");

var _TimeoutHelper = require("../../helpers/TimeoutHelper");

var _MuiAlertHelper = require("../../helpers/MuiAlertHelper");

var _CordovaHelper = require("../../helpers/CordovaHelper");

var _strings = require("../../../config/strings");

var _DeviceInfoHelper = _interopRequireDefault(require("../../helpers/DeviceInfoHelper"));

var _EquizzerRegisterHelper = require("../../common/components/Equizzer/EquizzerRegisterHelper");

var _UserManagementService = _interopRequireDefault(require("../../common/components/Equizzer/services/UserManagementService"));

/**
 * Created by falknisius on 30.05.17.
 *
 * use persistent DataStore
 * use axios for call register and get access_token
 *
 * onInstall:
 *      call init()
 *      try to register app @ auth-server using private credentials for basic auth
 *
 * onActivate:
 *      if not applicationInstanceId call init()
 *
 * getApplicationInstanceId:
 *      if not applicationInstanceId call init()
 *      return applicationInstanceId
 */
var TOKEN_URL = _BuildConstants.AUTH_HOST + '/oauth/token';
var REGISTER_URL = _BuildConstants.AUTH_HOST + '/rest/api/v1/registerInstance/application';

var RegisterInstance = /*#__PURE__*/function () {
  function RegisterInstance() {
    (0, _classCallCheck2["default"])(this, RegisterInstance);
  }

  (0, _createClass2["default"])(RegisterInstance, null, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _storeFeatures$equeoq, _storeFeatures$equeoq2, instanceId, regex, matches, storeFeatures, privateStore, storeAuth, isFromOldApp, _window$atob$split, _window$atob$split2, user, pwd, code, returnValue, authFromStore;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_config["default"]) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return (0, _TimeoutHelper.timeout)(150);

              case 3:
                return _context.abrupt("return", RegisterInstance.init());

              case 4:
                if (!RegisterInstance.isInitRunning) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return (0, _TimeoutHelper.timeout)(500);

              case 7:
                _context.next = 4;
                break;

              case 9:
                RegisterInstance.isInitRunning = true;
                _context.prev = 10;
                instanceId = null;

                if (_config["default"].useNativeDeviceUuid) {
                  // read uuid from URL
                  regex = /(?:deviceUuid=)(.*)(?=[#&])/g;
                  matches = window.location.href.match(regex);

                  if (matches && matches.length > 0 && matches[0].indexOf('=') > 0) {
                    instanceId = matches[0].split('=')[1];
                    console.log('application instance id retrieved from url: ', instanceId);
                  } else {
                    console.warn('tried to retrieve application instance from url according to config, but failed', window.location.href);
                  }
                }

                if (instanceId) {
                  _context.next = 18;
                  break;
                }

                _context.next = 16;
                return RegisterInstance._getInstanceIdFromStore();

              case 16:
                instanceId = _context.sent;
                console.log('+++register instance got from store', instanceId);

              case 18:
                _context.next = 20;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.FEATURES);

              case 20:
                storeFeatures = _context.sent;
                console.log('+++ features: ', storeFeatures);
                _context.next = 24;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.PRIVATE);

              case 24:
                privateStore = _context.sent;
                console.log('+++ private: ', privateStore);
                storeAuth = storeFeatures === null || storeFeatures === void 0 ? void 0 : (_storeFeatures$equeoq = storeFeatures.equeoqd) === null || _storeFeatures$equeoq === void 0 ? void 0 : (_storeFeatures$equeoq2 = _storeFeatures$equeoq.additionalData) === null || _storeFeatures$equeoq2 === void 0 ? void 0 : _storeFeatures$equeoq2._auth;
                isFromOldApp = storeAuth && !storeAuth.startsWith('Bearer');

                if (!(isFromOldApp && !RegisterInstance.isRevalidationRunning)) {
                  _context.next = 44;
                  break;
                }

                RegisterInstance.isRevalidationRunning = true;
                console.log('+++ is from old app!', storeAuth);
                _context.next = 33;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.APP_INSTANCE_AUTH_PATH, false);

              case 33:
                _window$atob$split = window.atob(storeAuth.split(' ')[1]).split(':'), _window$atob$split2 = (0, _slicedToArray2["default"])(_window$atob$split, 2), user = _window$atob$split2[0], pwd = _window$atob$split2[1];
                console.log('+++ user, pwd: ', user, pwd);
                _context.next = 37;
                return RegisterInstance.initAuth(instanceId, _config["default"].authScopes);

              case 37:
                _context.next = 39;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);

              case 39:
                code = _context.sent;
                _context.next = 42;
                return _UserManagementService["default"].revalidateUser(code, user, pwd, null, true);

              case 42:
                returnValue = _context.sent;
                console.log('+++ revalidate user returnValue: ', returnValue); // await registerUser(code, user, pwd, null, null, null, false, true)

              case 44:
                if (instanceId) {
                  _context.next = 59;
                  break;
                }

                instanceId = (0, _v["default"])();
                console.log('register instance got from uuid', instanceId);
                _context.next = 49;
                return RegisterInstance._setInstanceIdToStore(instanceId);

              case 49:
                _context.next = 51;
                return RegisterInstance._getAuthFromStore();

              case 51:
                authFromStore = _context.sent;

                if (authFromStore) {
                  _context.next = 59;
                  break;
                }

                if (!(_config["default"].authClient && _config["default"].authClientSecret)) {
                  _context.next = 57;
                  break;
                }

                setTimeout(function () {
                  RegisterInstance.initAuth(instanceId, _config["default"].authScopes);
                }, 0);
                _context.next = 59;
                break;

              case 57:
                _context.next = 59;
                return RegisterInstance._setAuthToStore(true);

              case 59:
                /*
                await DataStore.setSingleData(DATA_STORE_PATHS.APP_INSTANCE_AUTH_PATH, false)
                 const authFromStore = await RegisterInstance._getAuthFromStore()
                if (!authFromStore) {
                  // get Access Token
                  if (target.authClient && target.authClientSecret) {
                    console.log('+++ getting auth token')
                    setTimeout(function () { RegisterInstance.initAuth(instanceId, target.authScopes) }, 0)
                  } else {
                    await RegisterInstance._setAuthToStore(true)
                  }
                }
                */
                console.log('RegisterInstance.init() instanceId authScopes', instanceId, _config["default"].authScopes);
                RegisterInstance.isInitRunning = false;
                return _context.abrupt("return", _promise["default"].resolve());

              case 64:
                _context.prev = 64;
                _context.t0 = _context["catch"](10);
                RegisterInstance.isInitRunning = false;
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 68:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 64]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "initAuth",
    value: function () {
      var _initAuth = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(instanceId, scopes) {
        var appAuth;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!RegisterInstance.isAuthRunning) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 3;
                return (0, _TimeoutHelper.timeout)(_DeviceInfoHelper["default"].isOnline() ? 50 : 1000);

              case 3:
                _context2.next = 5;
                return RegisterInstance._getAuthFromStore();

              case 5:
                if (!_context2.sent) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", _promise["default"].resolve(true));

              case 7:
                _context2.next = 0;
                break;

              case 9:
                RegisterInstance.isAuthRunning = true;
                console.log('SEBO newInstanceId initAuth', instanceId);
                _context2.prev = 11;
                _context2.next = 14;
                return RegisterInstance._getAuthFromStore();

              case 14:
                appAuth = _context2.sent;

                if (!(appAuth === true)) {
                  _context2.next = 20;
                  break;
                }

                RegisterInstance.isAuthRunning = false;
                return _context2.abrupt("return", _promise["default"].resolve(true));

              case 20:
                if (!(!appAuth || !appAuth.clientId || !appAuth.clientSecret)) {
                  _context2.next = 26;
                  break;
                }

                console.log('SEBO newInstanceId initAuth pre _registerClient', instanceId);
                _context2.next = 24;
                return RegisterInstance._registerClient(instanceId);

              case 24:
                appAuth = _context2.sent;
                console.log('SEBO newInstanceId initAuth post _registerClient', instanceId);

              case 26:
                if (!appAuth.safetureAPI) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 29;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_KEYS, appAuth.safetureAPI);

              case 29:
                delete appAuth.safetureAPI;

              case 30:
                // request or renew Token
                if (appAuth.expires_at && typeof appAuth.expires_at === 'string') {
                  try {
                    appAuth.expires_at = new Date(appAuth.expires_at);

                    if (isNaN(appAuth.expires_at.getTime())) {
                      delete appAuth.expires_at;
                    }
                  } catch (error) {
                    delete appAuth.expires_at;
                  }
                } // if (!appAuth.access_token || !appAuth.expires_at || appAuth.expires_at.getTime() < new Date().getTime()) {
                //   console.log('register instance 9 access for scopes', appAuth)
                //   appAuth = await RegisterInstance._requestAccessForScopes(appAuth, scopes)
                //   console.log('register instance 9a after access for scopes', appAuth)
                //   console.log('register instance 9c auth set to stores', appAuth)
                // }


                _context2.next = 33;
                return RegisterInstance._setAuthToStore(appAuth);

              case 33:
                RegisterInstance.isAuthRunning = false;
                return _context2.abrupt("return", _promise["default"].resolve(true));

              case 35:
                _context2.next = 42;
                break;

              case 37:
                _context2.prev = 37;
                _context2.t0 = _context2["catch"](11);
                console.error(_context2.t0);
                RegisterInstance.isAuthRunning = false;
                return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

              case 42:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[11, 37]]);
      }));

      function initAuth(_x, _x2) {
        return _initAuth.apply(this, arguments);
      }

      return initAuth;
    }()
  }, {
    key: "_registerClient",
    value: function () {
      var _registerClient2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(instanceId) {
        var instanceIdToUse, storeId, registerAuth, answer, result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                instanceIdToUse = instanceId;
                console.log('SEBO registerClient', instanceIdToUse);

                if (instanceIdToUse) {
                  _context3.next = 9;
                  break;
                }

                console.log('SEBO no instance id, try to get from store, then try again');
                _context3.next = 7;
                return this._getInstanceIdFromStore();

              case 7:
                storeId = _context3.sent;
                instanceIdToUse = storeId;

              case 9:
                console.log('SEBO instanceId2', instanceIdToUse, instanceId);
                _context3.next = 12;
                return oauth2Client.getTokenForClient(_config["default"].authClient, _config["default"].authClientSecret, 'register');

              case 12:
                registerAuth = _context3.sent;
                _context3.next = 15;
                return oauth2Client.getRegisterClient(registerAuth.access_token, instanceIdToUse);

              case 15:
                answer = _context3.sent;
                result = {
                  clientId: instanceId,
                  clientSecret: answer.secret
                };
                if (answer.safetureAPI) result.safetureAPI = (0, _assign["default"])({}, answer.safetureAPI);
                return _context3.abrupt("return", _promise["default"].resolve(result));

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](0);
                console.error('_registerClient error', _context3.t0);

                if (_config["default"].showAuthError) {
                  (0, _MuiAlertHelper.showWideAlertHtml)("Bitte melden Sie sich erneut an<br /><br />".concat(_context3.t0.message), (0, _strings.getString)('ERROR'), false, {
                    label: 'OK',
                    callback: function callback() {
                      (0, _CordovaHelper.logOut)(true, null, false, 'RegisterInstance _registerClient');
                    }
                  });
                }

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 21]]);
      }));

      function _registerClient(_x3) {
        return _registerClient2.apply(this, arguments);
      }

      return _registerClient;
    }()
  }, {
    key: "_requestAccessForScopes",
    value: function () {
      var _requestAccessForScopes2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(appAuth, scopes) {
        var authResult, expiresAt;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return oauth2Client.getTokenForClient(appAuth.clientId, appAuth.clientSecret, scopes);

              case 2:
                authResult = _context4.sent;
                expiresAt = new Date(new Date().getTime() + 1000 * authResult.expires_in);
                return _context4.abrupt("return", _promise["default"].resolve((0, _assign["default"])({}, appAuth, {
                  expires_at: expiresAt
                }, authResult)));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function _requestAccessForScopes(_x4, _x5) {
        return _requestAccessForScopes2.apply(this, arguments);
      }

      return _requestAccessForScopes;
    }()
  }, {
    key: "_getInstanceIdFromStore",
    value: function () {
      var _getInstanceIdFromStore2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_DataStore["default"]) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.APP_INSTANCE_PATH));

              case 4:
                _context5.next = 6;
                return (0, _TimeoutHelper.timeout)(150);

              case 6:
                return _context5.abrupt("return", this._getInstanceIdFromStore());

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _getInstanceIdFromStore() {
        return _getInstanceIdFromStore2.apply(this, arguments);
      }

      return _getInstanceIdFromStore;
    }()
  }, {
    key: "_getInstanceIdFromStoreImmediately",
    value: function _getInstanceIdFromStoreImmediately() {
      return _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.APP_INSTANCE_PATH);
    }
  }, {
    key: "_setInstanceIdToStore",
    value: function () {
      var _setInstanceIdToStore2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(instanceId) {
        var data;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('setting instance id to store');
                data = {};
                data[_DataStore.DATA_STORE_PATHS.APP_INSTANCE_PATH] = instanceId;
                data[_DataStore.DATA_STORE_PATHS.APP_INSTANCE_CREATION_DATE] = (0, _now["default"])();
                _context6.next = 6;
                return _DataStore["default"].setData(data);

              case 6:
                return _context6.abrupt("return", _promise["default"].resolve(true));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function _setInstanceIdToStore(_x6) {
        return _setInstanceIdToStore2.apply(this, arguments);
      }

      return _setInstanceIdToStore;
    }()
  }, {
    key: "_authTokenValid",
    value: function _authTokenValid(token, expiresAt, scopes, whishedScopes) {
      if (!token) return false; // request or renew Token

      if (expiresAt && typeof expiresAt === 'string') {
        expiresAt = new Date(expiresAt);

        if (isNaN(expiresAt.getTime())) {
          return false;
        }
      }

      if (expiresAt.getTime() < new Date().getTime()) return false;
      if (!scopes) return false;
      var scopeList = scopes.split(' ');
      if (!whishedScopes) return false;
      var whisedScopeList = whishedScopes.split(' ');
      var scopeMissed = false;
      whisedScopeList.forEach(function (scope) {
        if (!(scopeList.indexOf(scope) >= 0)) {
          scopeMissed = true;
        }
      });
      return !scopeMissed;
    }
  }, {
    key: "generateNewInstanceId",
    value: function () {
      var _generateNewInstanceId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var instanceId;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                instanceId = (0, _v["default"])();
                console.log('SEBO newInstanceId', instanceId);
                _context7.next = 4;
                return this.initAuth(instanceId);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function generateNewInstanceId() {
        return _generateNewInstanceId.apply(this, arguments);
      }

      return generateNewInstanceId;
    }()
  }, {
    key: "_getAuthFromStore",
    value: function () {
      var _getAuthFromStore2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        var appAuth;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.APP_INSTANCE_AUTH_PATH);

              case 2:
                appAuth = _context8.sent;
                return _context8.abrupt("return", _promise["default"].resolve(appAuth));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function _getAuthFromStore() {
        return _getAuthFromStore2.apply(this, arguments);
      }

      return _getAuthFromStore;
    }()
  }, {
    key: "_setAuthToStore",
    value: function () {
      var _setAuthToStore2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(auth) {
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log('register instance 9b setAuthToStore');
                _context9.next = 3;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.APP_INSTANCE_AUTH_PATH, auth);

              case 3:
                console.log('register instance 9b setAuthToStore done');
                return _context9.abrupt("return", _promise["default"].resolve(true));

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function _setAuthToStore(_x7) {
        return _setAuthToStore2.apply(this, arguments);
      }

      return _setAuthToStore;
    }()
  }, {
    key: "_mixScopes",
    value: function _mixScopes(actualScopes, whishedScopes) {
      var result = _config["default"].authScopes.split(' ');

      if (actualScopes) {
        actualScopes.split(' ').forEach(function (scope) {
          if (!(result.indexOf(scope) >= 0)) result.push(scope);
        });
      }

      if (whishedScopes) {
        whishedScopes.split(' ').forEach(function (scope) {
          if (!(result.indexOf(scope) >= 0)) result.push(scope);
        });
      }

      return result.join(' ');
    }
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(scopes) {
        var i, appAuth, instanceId;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < 25)) {
                  _context10.next = 9;
                  break;
                }

                if (RegisterInstance.gettingAccessToken) {
                  _context10.next = 4;
                  break;
                }

                return _context10.abrupt("break", 9);

              case 4:
                _context10.next = 6;
                return (0, _TimeoutHelper.timeout)(500);

              case 6:
                i++;
                _context10.next = 1;
                break;

              case 9:
                if (!RegisterInstance.gettingAccessToken) {
                  _context10.next = 11;
                  break;
                }

                throw Error('Cannot get access token');

              case 11:
                RegisterInstance.gettingAccessToken = true;
                _context10.next = 14;
                return RegisterInstance._getAuthFromStore();

              case 14:
                appAuth = _context10.sent;

                if (appAuth) {
                  _context10.next = 24;
                  break;
                }

                _context10.next = 18;
                return RegisterInstance.getApplicationInstanceId();

              case 18:
                instanceId = _context10.sent;
                _context10.next = 21;
                return RegisterInstance.initAuth(instanceId, RegisterInstance._mixScopes(_config["default"].authScopes, scopes));

              case 21:
                _context10.next = 23;
                return RegisterInstance._getAuthFromStore();

              case 23:
                appAuth = _context10.sent;

              case 24:
                if (!(appAuth !== true)) {
                  _context10.next = 39;
                  break;
                }

                if (!RegisterInstance._authTokenValid(appAuth.access_token, appAuth.expires_at, appAuth.scope, scopes)) {
                  _context10.next = 29;
                  break;
                }

                console.log('auth token valid');
                RegisterInstance.gettingAccessToken = false;
                return _context10.abrupt("return", _promise["default"].resolve(appAuth.access_token));

              case 29:
                _context10.next = 31;
                return RegisterInstance._requestAccessForScopes(appAuth, RegisterInstance._mixScopes(appAuth.scope, scopes));

              case 31:
                appAuth = _context10.sent;
                _context10.next = 34;
                return RegisterInstance._setAuthToStore(appAuth);

              case 34:
                console.log('RegisterInstance.getAccessToken appAuth after renew', appAuth);
                RegisterInstance.gettingAccessToken = false;
                return _context10.abrupt("return", RegisterInstance.getAccessToken(scopes));

              case 39:
                RegisterInstance.gettingAccessToken = false;
                return _context10.abrupt("return", _promise["default"].resolve(null));

              case 41:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function getAccessToken(_x8) {
        return _getAccessToken.apply(this, arguments);
      }

      return getAccessToken;
    }()
  }, {
    key: "forceRenewAccessToken",
    value: function () {
      var _forceRenewAccessToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
        var appAuth;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                console.log('INFO', 'RegisterInstance.forceRenewAccessToken'); // Wait until free

              case 2:
                if (!true) {
                  _context11.next = 9;
                  break;
                }

                if (RegisterInstance.gettingAccessToken) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt("break", 9);

              case 5:
                _context11.next = 7;
                return (0, _TimeoutHelper.timeout)(50);

              case 7:
                _context11.next = 2;
                break;

              case 9:
                // lock gettingAccessToken
                RegisterInstance.gettingAccessToken = true; // get from Store

                _context11.next = 12;
                return RegisterInstance._getAuthFromStore();

              case 12:
                appAuth = _context11.sent;

                if (!((0, _typeof2["default"])(appAuth) === 'object' && appAuth.clientId && appAuth.clientSecret)) {
                  _context11.next = 21;
                  break;
                }

                if (appAuth.access_token) delete appAuth.access_token;
                if (appAuth.expires_at) delete appAuth.expires_at;
                if (appAuth.expires_in) delete appAuth.expires_in;
                if (appAuth.scope) delete appAuth.scope;
                if (appAuth.token_type) delete appAuth.token_type; // update Store

                _context11.next = 21;
                return RegisterInstance._setAuthToStore(appAuth);

              case 21:
                // console.log('INFO', 'RegisterInstance.forceRenewAccessToken appAuth after renew', appAuth)
                // unlock gettingAccessToken
                RegisterInstance.gettingAccessToken = false;
                _context11.next = 28;
                break;

              case 24:
                _context11.prev = 24;
                _context11.t0 = _context11["catch"](0);
                console.error('ERROR', 'RegisterInstance.forceRenewAccessToken', _context11.t0); // unlock gettingAccessToken

                RegisterInstance.gettingAccessToken = false;

              case 28:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 24]]);
      }));

      function forceRenewAccessToken() {
        return _forceRenewAccessToken.apply(this, arguments);
      }

      return forceRenewAccessToken;
    }()
  }, {
    key: "getApplicationInstanceId",
    value: function () {
      var _getApplicationInstanceId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
        var applicationInstanceId;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return RegisterInstance._getInstanceIdFromStore();

              case 2:
                applicationInstanceId = _context12.sent;

                if (applicationInstanceId) {
                  _context12.next = 9;
                  break;
                }

                _context12.next = 6;
                return RegisterInstance.init();

              case 6:
                _context12.next = 8;
                return RegisterInstance._getInstanceIdFromStore();

              case 8:
                applicationInstanceId = _context12.sent;

              case 9:
                return _context12.abrupt("return", _promise["default"].resolve(applicationInstanceId || null));

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function getApplicationInstanceId() {
        return _getApplicationInstanceId.apply(this, arguments);
      }

      return getApplicationInstanceId;
    }()
  }, {
    key: "getApplicationInstanceIdImmediately",
    value: function getApplicationInstanceIdImmediately() {
      return RegisterInstance._getInstanceIdFromStoreImmediately() || null;
    }
  }]);
  return RegisterInstance;
}();

RegisterInstance.isInitRunning = false;
RegisterInstance.isAuthRunning = false;
RegisterInstance.gettingAccessToken = false;
RegisterInstance.isRevalidationRunning = false;

var oauth2Client = /*#__PURE__*/function () {
  function oauth2Client() {
    (0, _classCallCheck2["default"])(this, oauth2Client);
  }

  (0, _createClass2["default"])(oauth2Client, null, [{
    key: "getTokenForClient",
    value: function () {
      var _getTokenForClient = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(clientId, clientSecret, scopes) {
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var onOnline = /*#__PURE__*/function () {
                    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
                      var userPwd, config, data, result;
                      return _regenerator["default"].wrap(function _callee13$(_context13) {
                        while (1) {
                          switch (_context13.prev = _context13.next) {
                            case 0:
                              console.log('online listener init auth');

                              _DeviceInfoHelper["default"].removeOnlineHiccupListener(onOnline);

                              userPwd = clientId + ':' + clientSecret;
                              config = {
                                headers: {
                                  'X-Requested-With': 'XMLHttpRequest',
                                  Authorization: 'Basic ' + window.btoa(userPwd)
                                },
                                timeout: 20000
                              };
                              data = new window.FormData();
                              if (scopes) data.append('scope', scopes);
                              data.append('grant_type', 'client_credentials');
                              _context13.prev = 7;
                              _context13.next = 10;
                              return _axios["default"].post(TOKEN_URL, data, config);

                            case 10:
                              result = _context13.sent;

                              if (result.status === 200) {
                                resolve(result.data);
                              } else {
                                console.error('thats my error!', result);
                                reject(new Error('Wrong request for Token: ' + result.status));
                              }

                              _context13.next = 22;
                              break;

                            case 14:
                              _context13.prev = 14;
                              _context13.t0 = _context13["catch"](7);
                              console.error('thats my error!', _context13.t0); // if we get an 401 here -> we have invalid credentials -> logOut!

                              if (!(_config["default"].resetAppOn401 && _context13.t0.toString().indexOf('401') !== -1)) {
                                _context13.next = 20;
                                break;
                              }

                              (0, _CordovaHelper.logOut)(true, null, false, 'RegisterInstance getTokenForClient resetAppOn401'); // no promise return because page is reloaded in logOut

                              return _context13.abrupt("return");

                            case 20:
                              console.error('Error requesting auth token. Have you called from file://? Then try starting a local server instead and load files from there.\n\tWith python: python -m SimpleHTTPServer 8080\n\tWith webstorm: open the index.html and choose open with Chrome or other browser.\n Error:', _context13.t0);
                              reject(new Error('Wrong request for Token: ' + _context13.t0.toString()));

                            case 22:
                            case "end":
                              return _context13.stop();
                          }
                        }
                      }, _callee13, null, [[7, 14]]);
                    }));

                    return function onOnline() {
                      return _ref.apply(this, arguments);
                    };
                  }();

                  if (!_DeviceInfoHelper["default"].isOnline(true)) {
                    console.log('not online at start');

                    _DeviceInfoHelper["default"].addOnlineHiccupListener(onOnline);

                    return;
                  }

                  console.log('online at start');
                  onOnline();
                }));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function getTokenForClient(_x9, _x10, _x11) {
        return _getTokenForClient.apply(this, arguments);
      }

      return getTokenForClient;
    }()
  }, {
    key: "getRegisterClient",
    value: function () {
      var _getRegisterClient = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(accessToken, applicationInstanceId) {
        var config, data, result, answer;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                config = {
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded'
                  } // timeout: 5000

                };
                data = new window.FormData();
                data.append('bundleId', window.BuildInfo && window.BuildInfo.packageName ? window.BuildInfo.packageName : null);
                _context15.prev = 3;
                _context15.next = 6;
                return _axios["default"].post(REGISTER_URL + '/' + applicationInstanceId, data, config);

              case 6:
                result = _context15.sent;

                if (!(result.status === 201 || result.status === 200)) {
                  _context15.next = 13;
                  break;
                }

                answer = {
                  secret: result.data.secret
                };
                if (result.data['savetureAPI']) answer.safetureAPI = (0, _assign["default"])({}, result.data['savetureAPI']);
                return _context15.abrupt("return", _promise["default"].resolve(answer));

              case 13:
                console.error(result);
                return _context15.abrupt("return", _promise["default"].reject(new Error('Wrong application registration ' + result.status + ' ' + (0, _stringify["default"])(result.data))));

              case 15:
                _context15.next = 20;
                break;

              case 17:
                _context15.prev = 17;
                _context15.t0 = _context15["catch"](3);
                return _context15.abrupt("return", _promise["default"].reject(new Error('Wrong application registration ' + _context15.t0.toString())));

              case 20:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[3, 17]]);
      }));

      function getRegisterClient(_x12, _x13) {
        return _getRegisterClient.apply(this, arguments);
      }

      return getRegisterClient;
    }()
  }]);
  return oauth2Client;
}();

var _default = RegisterInstance;
exports["default"] = _default;